import Arg from '@spothero/arg';
import SearchRequestUtils from 'search-request/search-request-utils';
import {initialState as searchRequestInitialState} from 'search-request/search-request-reducer';
import SearchUtils from 'search/search-utils';
import ExperimentUtils from 'utils/experiment';
import SearchAPI from 'api/search';

export async function createCleanedData({
    currentCity,
    cleanedParams,
    currentSearchState,
    checkoutState = {},
}) {
    const {
        page_info: {page_type: pageType, setup},
        rid,
    } = cleanedParams;
    const loadedData = await SearchRequestUtils.loadDataSequence({
        pageType,
        setup,
        isNewCity: setup.city.slug !== currentCity.data.slug,
    });
    const cleanedData = {
        searchRequest: SearchRequestUtils.sanitizeSearchRequestResponse({
            state: searchRequestInitialState,
            response: cleanedParams,
        }),
        checkout: {...checkoutState, rid},
        ...loadedData,
    };

    if (!cleanedData.city) {
        cleanedData.city = currentCity;
    }

    cleanedData.search = SearchUtils.prepareStoreData({
        initData: cleanedData,
        experimentUtils: ExperimentUtils,
        pageType,
        currentSearchState,
    });

    return cleanedData;
}

export async function fetchCleanedData({state, route}) {
    const {city, search: searchState, checkout: checkoutState} = state;
    const {
        location: {pathname, search},
    } = route;
    const {
        data: {data: cleanedParams},
    } = await SearchAPI.cleanParams({url: `${pathname}${search || ''}`});

    return createCleanedData({
        currentCity: city,
        cleanedParams,
        currentSearchState: searchState,
        checkoutState,
    });
}

export function routeToSearch({
    method,
    pageType = 'address',
    id,
    queryParams = {},
    historyState = {},
}) {
    // TODO: right now the search-params endpoint returns 'search' instead of 'address' for default page type
    // the new endpoint that replaces search-params should return a better aligned mapping to the page types we are
    // expecting in this method, 'search' should become 'address' and 'venue' should become 'destination'
    // venue determination happens on the FE only, as in, a destination that has events
    const kind =
        pageType === 'venue'
            ? 'destination'
            : pageType === 'search'
            ? 'address'
            : pageType;
    const query = Arg.stringify({
        kind,
        // pageType 'address' does not have an associated ID
        ...(id && {id}),
        ...queryParams,
    });

    method(`/search?${query}`, historyState);
}

export function routeToSpotDetails({
    method,
    location: {pathname, search},
    spotId,
    historyState = {},
}) {
    const query = Arg.stringify({
        ...Arg.parse(search),
        'spot-id': spotId,
    });

    method(`${pathname}?${query}`, historyState);
}
